'use client';

import type { Ref } from 'react';

import classnames from 'classnames';

import type { TextareaProps } from './Textarea.types';

import styles from './Textarea.module.scss';

export function Textarea({
  style,
  className,
  error = false,
  testId = 'ui-textarea',
  ref,
  ...rest
}: TextareaProps & { ref?: Ref<HTMLTextAreaElement> }) {
  return (
    <textarea
      ref={ref}
      style={style}
      className={classnames(
        styles['textarea'],
        error && styles['textarea--error'],
        rest.disabled && styles['textarea--disabled'],
        className,
      )}
      data-testid={testId}
      {...rest}
    />
  );
}
